// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"391":"8fca147fdfe690b9","3877":"fe336940f98fdfab","4473":"dd5bf6130a79645b","6272":"aa4472f7082b94cd","7584":"d9652db206d50763"}[chunkId] + ".css";
};